import React from 'react';
import ReactDOM from 'react-dom/client';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import {store} from "./store";

// One line spinner everywhere, instead of antd's four rotating dots.
//
// Set here rather than in App.tsx so it is in place before ANY component
// renders, including lazily-loaded admin chunks and anything that spins during
// the first paint.
//
// antd clones this element onto its own `.ant-spin-dot` class, which carries
// the per-size font-size (14px small / 20px default / 32px large). Because
// LoadingOutlined renders at 1em it inherits that, so size="small" and
// size="large" keep working without any of this hard-coding a pixel value.
// The colour comes from the surrounding `.ant-spin`, so it still follows
// whatever primary colour is in context.
//
// This is antd 5.16: ConfigProvider's `spin` prop is style-only until a later
// version, so setDefaultIndicator is the supported hook here.
Spin.setDefaultIndicator(<LoadingOutlined spin />);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
